<!-- ***************SG-4637 start  ******************* -->

<mat-card fxLayout="column" fxFlex="100%" style="padding: 4px;" class="mat-elevation-z8">
    <mat-card-subtitle cardHeader style="padding-top: 7px;">

        <div class="export-icon"> <span class="mission-heading">Lesson Records</span>

            <!-- <i class="fa fa-share-square-o" aria-hidden="true"
                style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                (click)="exportCsvData('performance')"></i> -->
        </div>

    </mat-card-subtitle>

    <div class="table-class">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" width="100%">
            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header width="30%"> Name </th>
                <td mat-cell *matCellDef="let element" (click)="openMission(element)" style="white-space: nowrap;text-align: justify;padding-left: 0% !important;"
                    [matTooltip]="element.title" pointer>
                    <a class="underline"> {{element.title}} </a>
                </td>
            </ng-container>
            <ng-container matColumnDef="sessionsPlayed">
                <th mat-header-cell *matHeaderCellDef mat-sort-header width="20%"> Sessions </th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.sessionsPlayed" pointer>
                    {{element.sessionsPlayed}} </td>
            </ng-container>
            <ng-container matColumnDef="clearedSessionCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header width="20%"> Cleared </th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.clearedSessionCount" pointer>
                    {{element.clearedSessionCount}} </td>
            </ng-container>
            <ng-container matColumnDef="failedCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> Not Cleared </th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.failedCount" pointer>
                    {{element.failedCount}} </td>
            </ng-container>
            <ng-container matColumnDef="percentageCompleteLesson">
                <th mat-header-cell *matHeaderCellDef mat-sort-header width="15%"> % Correct </th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.percentageCompleteLesson" pointer>
                    {{element.percentageCompleteLesson}}% </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;" pointer></tr>
        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[5,10, 25, 50]" [pageSize]="pageSize"
        [length]="missionRecords && missionRecords.length" (page)="onPageChange($event)"></mat-paginator>
</mat-card>
<!-- ***************SG-4637 end  ******************* -->